import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { toLocalTimeMinutes, toLocalDate } from "../../../../../utils/v3/utils/datetime.js";
import { GET_CALENDAR_AVAILABILITY_BY_ID } from "../../../../../queries/v3/queries/get-calendar-availability-by-id.js";
import { fromCalendarAvailabilityByIdQueryToCalendarAvailability } from "../../../adapters/v3/hooks/api/adapters/fromCalendarAvailabilityByIdQueryToCalendarAvailability.js";
const useCalendarAvailabilityById = () => {
  const [query, queryState] = useLazyQuery(GET_CALENDAR_AVAILABILITY_BY_ID, {
    fetchPolicy: "no-cache",
    context: {
      timeout: 35e3
    }
  });
  const getCalendarAvailability = React.useCallback(
    ({
      appointmentTypeId,
      globalStoreId,
      startDate,
      endDate,
      startTime,
      endTime
    }) => {
      query({
        variables: {
          appointmentTypeIds: [appointmentTypeId],
          globalStoreIds: [globalStoreId],
          startDate: toLocalDate(startDate),
          endDate: toLocalDate(endDate),
          startTime: startTime ? toLocalTimeMinutes(startTime) : void 0,
          endTime: endTime ? toLocalTimeMinutes(endTime) : void 0
        }
      });
    },
    [query]
  );
  const data = React.useMemo(
    () => fromCalendarAvailabilityByIdQueryToCalendarAvailability(queryState.data),
    [queryState.data]
  );
  const { called, error, loading } = queryState;
  return React.useMemo(
    () => [getCalendarAvailability, { called, loading, data, error }],
    [getCalendarAvailability, called, loading, data, error]
  );
};
export {
  useCalendarAvailabilityById as default
};
//# sourceMappingURL=use-calendar-availability-by-id.js.map
